import Cookies from 'js-cookie'

const TokenKey = 'token'
const MenuId = 'menuId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  window.sessionStorage.setItem(TokenKey, token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  window.sessionStorage.removeItem(TokenKey)
  return Cookies.remove(TokenKey)
}

export function getSessionToken() {
  return window.sessionStorage.getItem(TokenKey)
}

// 菜单ID
export function getMenuId() {
  return window.sessionStorage.getItem(MenuId) || Cookies.get(MenuId)
}

export function setMenuId(menuId) {
  window.sessionStorage.setItem(MenuId,menuId)
  return Cookies.set(MenuId, menuId)
}

export function removeMenuId() {
  return Cookies.remove(MenuId)
}
